import React from 'react'

import { Button } from './Button'

import clcontactPDF from 'assets/cl-resources/clcontact.pdf'
import clcontactImage from 'assets/cl-resources/clcontact.jpg'
import styled from 'styled-components'
import { Color, Operation, Responsive, Size } from 'const'
import ImageViewer from './ImageViewer'
import { useMediaQuery } from 'react-responsive'

const ClViewer = ({ isContactLens, isBeforeOrEqual31thMarch2025, custom = true }) => {
  const [visibleWarrantyViewer, setVisibleWarrantyViewer] = React.useState(false)
  const isSM = useMediaQuery({
    query: `(max-width: ${Responsive.MD.DOWN}px)`,
  })

  const warrantyPdfLink = isContactLens
    ? clcontactPDF
    : isBeforeOrEqual31thMarch2025
    ? Operation.before.warranty
    : Operation.after.warranty

  const operatingInstructionPdfLink = isContactLens
    ? ''
    : isBeforeOrEqual31thMarch2025
    ? Operation.before.instruction
    : Operation.after.instruction

  const warranty = {
    buttonText: isSM && custom ? '保証書' : '保証書を閲覧する',
    downloadText: '保証書（PDFをダウンロード）',
    downloadFileName: isContactLens ? 'clcontact.pdf' : 'warranty.pdf',
    onClick: () => {
      if (isContactLens) {
        setVisibleWarrantyViewer(true)

        return
      }
      window.open(warrantyPdfLink, '_blank', "rel='noopener noreferrer'")
    },
    href: isContactLens ? clcontactPDF : warrantyPdfLink,
  }

  const operatingInstruction = {
    buttonText: isSM && custom ? '取扱説明書' : '取扱説明書を閲覧する',
    downloadText: '取り扱い説明書（PDFをダウンロード）',
    downloadFileName: 'operating-manual.pdf',
    onClick: () => {
      window.open(operatingInstructionPdfLink, '_blank', "rel='noopener noreferrer'")
    },
    href: operatingInstructionPdfLink,
  }

  const downloadCaution = isContactLens
    ? '※PDFファイルのため、パソコンでのダウンロードを推奨します。'
    : '※ PDFファイルのため、お使いのパソコンやスマホからダウンロード・印刷が可能です。'

  return (
    <ClViewerContainer>
      <DownloadWrapper custom={custom}>
        <Button fontSize="18px" type="button" primary onClick={warranty.onClick} style={{ marginTop: 0 }}>
          {warranty.buttonText}
        </Button>
        {isContactLens && (
          <a href={warranty.href} download={warranty.downloadFileName} target="_blank" rel="noopener noreferrer">
            {warranty.downloadText}
          </a>
        )}
      </DownloadWrapper>

      {!isContactLens && (
        <>
          <Separator />
          <DownloadWrapper custom={custom}>
            <Button
              fontSize="18px"
              type="button"
              primary
              onClick={operatingInstruction.onClick}
              style={{ marginTop: 0 }}
            >
              {operatingInstruction.buttonText}
            </Button>
          </DownloadWrapper>
        </>
      )}
      {isContactLens && (
        <ImageViewer
          isOpen={visibleWarrantyViewer}
          onClose={() => setVisibleWarrantyViewer(false)}
          imgSrc={clcontactImage}
        />
      )}
      <Separator />
      <DownloadCaution>{downloadCaution}</DownloadCaution>
    </ClViewerContainer>
  )
}

const Separator = styled.div`
  height: 1px;
  background-color: ${Color.GREY};
`

const ClViewerContainer = styled.div`
  border-top: 1px solid ${Color.GREY};
  flex: 1;
`

const DownloadWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 30px 0 30px;
  > a {
    line-height: 24px;
    margin-top: 20px;
  }

  ${(props) =>
    props.custom &&
    `
      @media screen and (max-width: 799.99px) {
        button {
          min-width: auto;
          width: auto;
          min-height: auto;
        }
    }
  `}
`

const DownloadCaution = styled.p`
  text-align: center;
  margin: 20px 0;
  letter-spacing: 0 !important;
  font-weight: 500;
  font-size: ${Size.FONT.NORMAL};
  font-family: Noto Sans JP;
`

export default ClViewer
